import apiService from './apiService';

const getCategories = (section, proxiedAsId) => {
	const url = `/Categories${apiService.paramsToQuery({
		section,
		proxiedAsId
	})}`;

	return apiService.get(url);
};

export default {
	getCategories
};